module.exports = __webpack_public_path__ + "img/send.560f4c22.svg";